import { useQuery } from '@tanstack/react-query'
import service from '@/utils/https'

function isCompleteEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
}

async function fetchSsoOnly(email: string): Promise<boolean> {
  const response = await service.get('/api/app/v1/auth/sso/policy', {
    params: { email },
    hideMessageModal: true,
  })
  return response.data?.data?.ssoOnly === true
}

/**
 * SSO obligatoire pour les membres, freelances et invitations de l'équipe Folkyn.
 * Une adresse @folkyn.com hors de cette équipe garde les autres modes de connexion.
 */
export function useSsoLoginRequired(email: string): boolean {
  const normalized = email.trim().toLowerCase()
  const { data } = useQuery({
    queryKey: ['auth', 'ssoPolicy', normalized],
    queryFn: () => fetchSsoOnly(normalized),
    enabled: isCompleteEmail(normalized),
    staleTime: 60_000,
  })

  return data === true
}
